import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import * as appConst from "../../Common/constants";
import { SelectButton } from "primereact/selectbutton";
import { Dropdown } from "primereact/dropdown";

class AccountsAddEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      txndate: "",
      amount: 0.0,
      source: "",
      Banks: [],
      bankName: ""
    };

    this.handleTxnDateChange = this.handleTxnDateChange.bind(this);
  }

  componentDidMount() {
    this.LoadBanks();
  }

  LoadBanks() {
    let _bankList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/Bank"
      )
      .then(response => {
        let bankData = response.data;

        bankData.forEach(function(item) {
          if (item.cash == false) {
            var obj = { label: item.name, value: item.name };
            _bankList.push(obj);
          }
        });
        this.setState({ Banks: _bankList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    const CESource = [
      { label: "Cash", value: "Cash" },
      { label: "Bank", value: "Bank" }
    ];

    return (
      <div>
        <div>
          <h4 align="center"> Contra Entry</h4>
        </div>
        <div>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Txn Date</div>
              <div className="col col-md-3">
                <DatePicker
                  selected={this.state.txndate}
                  onChange={this.handleTxnDateChange}
                  dateFormatCalendar={"MMM yyyy"}
                  minDate={subMonths(new Date(), 10)}
                  maxDate={new Date()}
                  showMonthYearDropdown
                  dateFormat="dd-MMM-yyyy"
                  width="300px"
                  // style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>

            <div className="row p-1 border">
              <div className="col col-md-2">Amount</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.amount}
                  onChange={e => this.setState({ amount: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Source</div>
              <div className="col col-md-3">
                <SelectButton
                  value={this.state.source}
                  options={CESource}
                  onChange={this.onSourceChange}
                  className="p-error"
                />
              </div>
            </div>

            <div className="row p-1 border">
              <div className="col col-md-2">Bank</div>
              <div className="col col-md-3">
                <Dropdown
                  value={this.state.bankName}
                  options={this.state.Banks}
                  placeholder="Select Bank"
                  onChange={this.onBankChange}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className="btn btn-primary btn-md mr-2"
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
            <Messages ref={el => (this.messages = el)} />
          </div>
        </div>
      </div>
    );
  }

  onBankChange = e => {
    this.setState({ bankName: e.target.value });
  };

  onSourceChange = e => {
    this.setState({ source: e.value });
  };

  handleTxnDateChange(txndate) {
    this.setState({ txndate });
  }

  onSaveClick = e => {
    e.preventDefault();

    if (
      this.state.txndate === "" ||
      this.state.source === "" ||
      this.state.source === null ||
      this.state.amount === 0 ||
      this.state.bankName === ""
    ) {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Mandatory Fields"
      });
    } else {
      const obj = {
        txndate: this.state.txndate,
        source: this.state.source,
        bankName: this.state.bankName,
        amount: this.state.amount
      };
      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
            
            "/account/addCE",
          obj
        )
        .then(res => {
          this.props.onClick("List", "");
        });
      this.growl.show({
        severity: "success",
        summary: "Success",
        detail: this.props.txnType + " Added !!!"
      });
    }
  };

  ClearData() {
    this.setState({
      txndate: "",
      amount: 0,
      source: "",
      bankName: ""
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default AccountsAddEdit;
